"use strict";

var _interopRequireDefault = require("/build-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.string.repeat");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
var _objectWithoutProperties2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/objectWithoutProperties.js"));
var _toConsumableArray2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _vuex = require("vuex");
var _Breadcrumb = _interopRequireDefault(require("@/components/Breadcrumb"));
var _Hamburger = _interopRequireDefault(require("@/components/Hamburger"));
var _Screenfull = _interopRequireDefault(require("@/components/Screenfull"));
var _SizeSelect = _interopRequireDefault(require("@/components/SizeSelect"));
var _Notice = _interopRequireDefault(require("@/components/Notice"));
var _HeaderSearch = _interopRequireDefault(require("@/components/HeaderSearch"));
var _resetCode = _interopRequireDefault(require("./resetCode"));
var _lodash = _interopRequireDefault(require("lodash.clonedeep"));
var _moment = _interopRequireDefault(require("moment"));
var _WorkOrderEntity = _interopRequireDefault(require("@services/WorkOrderEntity"));
var _closeDialog = _interopRequireDefault(require("@/views/WorkOrderList/components/closeDialog"));
var _UnsolvedDialog = _interopRequireDefault(require("@/views/WorkOrderList/components/UnsolvedDialog"));
var _EditDialog = _interopRequireDefault(require("@/views/WorkOrderList/components/EditDialog"));
var _LookDetail = _interopRequireDefault(require("@/views/WorkOrderList/components/LookDetail"));
var _excluded = ["field_msg", "urgent_status", "type_name", "question_name", "config_name", "apply_user_id", "optid", "workorder_time", "update_time", "solved_time", "day", "close_time", "json_file"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import SearchResultTable from '@/views/WorkOrderList/components/SearchResultTable'
var _default = exports.default = {
  components: {
    Breadcrumb: _Breadcrumb.default,
    Hamburger: _Hamburger.default,
    Screenfull: _Screenfull.default,
    SizeSelect: _SizeSelect.default,
    Search: _HeaderSearch.default,
    Notice: _Notice.default,
    ResetCode: _resetCode.default,
    CloseDialog: _closeDialog.default,
    UnsolvedDialog: _UnsolvedDialog.default,
    EditDialog: _EditDialog.default,
    LookDetail: _LookDetail.default
  },
  data: function data() {
    return {
      roleGrow: {},
      treeLoading: false,
      roleUserData: [],
      // 树形结构展开数组
      unfoldRole: [],
      defaultProps: {
        children: "children",
        label: "nickname"
      },
      checkVal: true,
      dialogTableVisible: false,
      loading_transfer: false,
      batchBtnList: {},
      attrTable: {},
      checkedList: [],
      roleData: {
        username: ""
      },
      maxHeight: 0,
      sysPanelListIndex: 999,
      totalData: 0,
      API_Work: true,
      displayTable: [],
      tableData: [],
      btnShoeMore: true,
      currentPageSize: 20,
      currentPage: 1,
      // 标记工单处理
      signDetail: {
        wid: ""
      },
      // 撤销
      revocation: {
        user_name: localStorage.getItem("userName"),
        id: "",
        group: localStorage.getItem("roleIdsName")
      },
      dialogFormVisible: false,
      // 转单后台接口需要的数据
      transferForm: {
        user_name: localStorage.getItem("userName"),
        id: "",
        nick_name: "",
        // group: '',
        operation_group: localStorage.getItem("roleIdsName")
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(["sidebar", "avatar", "device", "overList", "isPinOver", "unregulatedTotal"])), {}, {
    setting: {
      get: function get() {
        return this.$store.state.settings.showSettings;
      },
      set: function set(val) {
        this.$store.dispatch("settings/changeSetting", {
          key: "showSettings",
          value: val
        });
      }
    }
  }),
  watch: {
    tableData: {
      handler: function handler(val) {
        this.lookPrivacyBox = true;
        this.getTableData(val);
      },
      deep: true,
      immediate: true
    },
    // 待受理数量
    // unregulatedTotal: {
    //   handler(val) {
    //     console.log("待受理数量更新");
    //     this.getOvertime();
    //   }
    // },
    overList: function overList(nv) {
      console.log("navbar页面，超时工单+1");
      this.getOvertime();
    }
  },
  mounted: function mounted() {
    if (this.isPinOver == "1") {
      this.checkVal = true;
    } else {
      this.checkVal = false;
    }
    this.getOvertime();
  },
  methods: {
    searchusername: function searchusername() {
      this.getRoleList(1);
    },
    tableRowName: function tableRowName(_ref) {
      var row = _ref.row,
        rowIndex = _ref.rowIndex;
      if (row.isPinOver === 1) {
        return {
          background: "rgb(249 241 246)"
        };
      }
      if ((rowIndex + 1) % 2 === 0) {
        return {
          background: "#EFF9E6"
        };
      } else {
        return "";
      }
    },
    // 赋值成功或失败
    onCopy: function onCopy() {
      this.$message({
        message: this.$t("copySuccess") + "！",
        type: "success"
      });
    },
    onError: function onError() {
      this.$message({
        message: this.$t("copyFailed") + "！",
        type: "error"
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      console.log("\u6BCF\u9875 ".concat(val, " \u6761"));
      this.currentPageSize = val;
      this.getOvertime();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      console.log("\u5F53\u524D\u9875: ".concat(val));
      this.currentPage = val;
      this.getOvertime();
    },
    freshList: function freshList() {
      this.getOvertime();
    },
    resetOperaBtn: function resetOperaBtn() {
      // this.batchBtnNum1 = []
      this.batchBtn = [];
      // 鼠标离开之后的操作
    },
    getOvertime: function () {
      var _getOvertime = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var inner, params, listData, code, msg, data, total;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.tableDataOriginal = [];
              inner = this.loading;
              if (!inner) this.loading = true;
              _context.prev = 3;
              _context.next = 6;
              return this.getFieldAttr();
            case 6:
              params = {
                action: "get",
                // workorder_status: 1,
                row: this.currentPageSize,
                page: this.currentPage,
                checked: false,
                is_overtime: 1
              };
              _context.next = 9;
              return _WorkOrderEntity.default.getList(params);
            case 9:
              listData = _context.sent;
              code = listData.code, msg = listData.msg, data = listData.data, total = listData.total;
              if (code === 200) {
                this.API_Work = true;
                this.fresh = true;
                this.totalData = total || 0;
                this.tableDataOriginal = (0, _toConsumableArray2.default)(data || []).map(function (item) {
                  var obj = {};
                  var field_msg = item.field_msg,
                    urgent_status = item.urgent_status,
                    type_name = item.type_name,
                    question_name = item.question_name,
                    config_name = item.config_name,
                    apply_user_id = item.apply_user_id,
                    optid = item.optid,
                    workorder_time = item.workorder_time,
                    update_time = item.update_time,
                    solved_time = item.solved_time,
                    day = item.day,
                    close_time = item.close_time,
                    json_file = item.json_file,
                    attrs = (0, _objectWithoutProperties2.default)(item, _excluded);
                  obj = Object.assign({}, _objectSpread({}, attrs), {
                    info: JSON.parse(field_msg) || JSON.parse(json_file),
                    attr: {
                      urgent_status: urgent_status,
                      type_name: type_name,
                      question_name: question_name,
                      config_name: config_name
                    },
                    people: {
                      apply_user_id: apply_user_id,
                      optid: optid
                    },
                    time: {
                      workorder_time: workorder_time,
                      update_time: update_time,
                      solved_time: solved_time,
                      close_time: close_time,
                      day: day,
                      period: (0, _moment.default)(close_time || new Date()).diff((0, _moment.default)(workorder_time), "days") + 1
                    }
                  });
                  return obj;
                });

                // 获取操作按钮
                this.getBtnList();
              } else {
                this.loading = false;
                this.API_Work = false;
                this.fresh = false;
                this.$message.error(msg);
              }
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](3);
              this.loading = false;
            case 17:
              if (!inner) this.loading = false;
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 14]]);
      }));
      function getOvertime() {
        return _getOvertime.apply(this, arguments);
      }
      return getOvertime;
    }(),
    // 给操作添加按钮添加数组
    getBtnList: function () {
      var _getBtnList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this = this;
        var obj, _yield$EntityService$, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              obj = {};
              obj.id = this.tableDataOriginal.map(function (item) {
                return item.id;
              });
              _context2.next = 4;
              return _WorkOrderEntity.default.getOperaBtn(obj);
            case 4:
              _yield$EntityService$ = _context2.sent;
              data = _yield$EntityService$.data;
              this.batchBtnList = data;
              this.tableDataOriginal.map(function (item) {
                item.batchBtn = _this.batchBtnList[item.id];
              });
              this.tableData = this.tableDataOriginal;
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getBtnList() {
        return _getBtnList.apply(this, arguments);
      }
      return getBtnList;
    }(),
    // 点击查看
    getTableData: function getTableData(val) {
      this.displayTable = (this.tableData || val).map(function (row) {
        row.btnLoading = true;
        var clone = (0, _lodash.default)(row);
        return clone;
      });
    },
    // 操作按钮
    getOperaBtn: function () {
      var _getOperaBtn = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(type, rowData, index) {
        var obj, _yield$EntityService$2, data, temArr, key, element, arr1, arr2, operaNum, filterNum;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // return
              obj = {}; // 批量操作获取下一步操作
              if (!(type === 1)) {
                _context3.next = 6;
                break;
              }
              this.btnShoeMore = false;
              obj.id = this.selectData.map(function (item) {
                return item.id;
              });
              _context3.next = 7;
              break;
            case 6:
              return _context3.abrupt("return", this.$set(this.displayTable[index], "batchBtn", this.batchBtnList[rowData.id]));
            case 7:
              this.batchBtnNum1 = [];
              _context3.prev = 8;
              _context3.next = 11;
              return _WorkOrderEntity.default.getOperaBtn(obj);
            case 11:
              _yield$EntityService$2 = _context3.sent;
              data = _yield$EntityService$2.data;
              if (!(type === 1)) {
                _context3.next = 23;
                break;
              }
              if (!(Array.isArray(data) && !data.length)) {
                _context3.next = 16;
                break;
              }
              return _context3.abrupt("return", this.$message.error(this.$t("authTips")));
            case 16:
              // let btnIndex = []
              temArr = Object.keys(data[Object.keys(data)[0]]);
              for (key in data) {
                if (Object.hasOwnProperty.call(data, key)) {
                  element = Object.keys(data[key]); // btnIndex = btnIndex.concat(element)
                  arr1 = temArr;
                  arr2 = element;
                  temArr = this.repeat(arr1, arr2);
                }
              }
              // 筛选出数组中相同的元素
              // const arrNum = this.duplicates(btnIndex)
              this.btnShoeMore = true;
              this.batchBtnNum1 = temArr;
              operaNum = Object.keys(this.opera);
              filterNum = this.repeat(operaNum, temArr);
              if (filterNum.length === 0) {
                this.$message.error(this.$t("authTips"));
              }
            case 23:
              _context3.next = 28;
              break;
            case 25:
              _context3.prev = 25;
              _context3.t0 = _context3["catch"](8);
              console.log(_context3.t0);
            case 28:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[8, 25]]);
      }));
      function getOperaBtn(_x, _x2, _x3) {
        return _getOperaBtn.apply(this, arguments);
      }
      return getOperaBtn;
    }(),
    handleCommand: function () {
      var _handleCommand = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(key, type, data, isMass) {
        var num, obj, methods, title, _title, _title2, res, _res, code, msg;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              // 获取id
              // 大统一参数
              num = key;
              if (!(key === "99")) {
                _context4.next = 4;
                break;
              }
              if (data.id) {
                this.$emit("handlerMark", data);
              } else {
                this.$emit("handlerMark", this.checkedList, 3);
              }
              return _context4.abrupt("return");
            case 4:
              obj = {
                status: num,
                optid: localStorage.name
              };
              if (type === 0) {} else {
                // 列表里单个操作
                obj.id = data.id;
              }
              // 单个操作
              methods = "updateOrderStatus"; // 不同的接口接口地址切换
              if (!(data.batchBtn[key] === this.$t("revoke"))) {
                _context4.next = 11;
                break;
              }
              this.revocation.id = data.id;
              this.getRevocation();
              return _context4.abrupt("return");
            case 11:
              if (!(data.batchBtn[key] === this.$t("transfer"))) {
                _context4.next = 17;
                break;
              }
              this.roleData.username = "";
              this.transferForm.id = data.id;
              this.dialogFormVisible = true;
              this.workOrderLimit(data.id);
              return _context4.abrupt("return");
            case 17:
              if (!(data.batchBtn[key] === this.$t("markedAsTruckingTicket") || data.batchBtn[key] === this.$t("cancelObservationTicket"))) {
                _context4.next = 21;
                break;
              }
              this.signDetail.wid = data.id;
              this.getMarkObservation();
              return _context4.abrupt("return");
            case 21:
              if (!(data.batchBtn[key] === this.$t("close"))) {
                _context4.next = 27;
                break;
              }
              obj.id = data.id;
              // obj.public_mark = data.public_mark
              // obj.private_mark = data.private_mark
              obj.public_mark = "";
              obj.private_mark = "";
              this.$refs.close.open(obj, 0);
              return _context4.abrupt("return");
            case 27:
              if (!(data.batchBtn[key] === this.$t("confirmClose"))) {
                _context4.next = 33;
                break;
              }
              obj.id = data.id;
              // obj.public_mark = data.public_mark
              // obj.private_mark = data.private_mark
              obj.public_mark = "";
              obj.private_mark = "";
              this.$refs.close.open(obj, 1);
              return _context4.abrupt("return");
            case 33:
              if (!(data.batchBtn[key] === this.$t("revise"))) {
                _context4.next = 37;
                break;
              }
              obj.id = data.id;
              this.$refs.edit.open(data.id, this.sysPanelListIndex === 999 ? 0 : this.sysPanelListIndex);
              return _context4.abrupt("return");
            case 37:
              if (!(data.batchBtn[key] === this.$t("markedAsPending"))) {
                _context4.next = 42;
                break;
              }
              title = this.$t("markedAsPending");
              obj.id = data.id;
              this.$refs.unsolved.open(title, obj, {});
              return _context4.abrupt("return");
            case 42:
              if (!(data.batchBtn[key] === this.$t("markedAsSolve"))) {
                _context4.next = 47;
                break;
              }
              _title = this.$t("markedAsSolve");
              obj.id = data.id;
              // this.$refs.unsolved.open(title, obj, data)
              this.$refs.unsolved.open(_title, obj, {});
              return _context4.abrupt("return");
            case 47:
              if (!(data.batchBtn[key] === this.$t("markedAsUnsolve"))) {
                _context4.next = 52;
                break;
              }
              _title2 = this.$t("markedAsUnsolve");
              obj.id = data.id;
              this.$refs.unsolved.open(_title2, obj, {});
              return _context4.abrupt("return");
            case 52:
              res = {}; // return
              _context4.next = 55;
              return _WorkOrderEntity.default[methods](_objectSpread({}, obj));
            case 55:
              res = _context4.sent;
              _res = res, code = _res.code, msg = _res.msg;
              if (code === 200) {
                this.getOvertime();
                this.$refs.multipleTable.clearSelection();
                this.$message.success(this.$t("operationSuccessful"));
                this.$emit("fresh");
              } else {
                this.$message.error(msg);
              }
            case 58:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handleCommand(_x4, _x5, _x6, _x7) {
        return _handleCommand.apply(this, arguments);
      }
      return handleCommand;
    }(),
    handleDetails: function handleDetails(_ref2) {
      var id = _ref2.id;
      this.$refs.detailDialog.open(id, this.sysPanelListIndex);
      // this.$router.push({
      //   path: '/work_order_detail',
      //   query: { id, configId: this.sysPanelListIndex },
      // })
    },
    // 批量操作处理中接口
    handleDispose: function () {
      var _handleDispose = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(data1) {
        var _yield$EntityService$3, msg, code;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _WorkOrderEntity.default.updateOrderStatus(data1);
            case 2:
              _yield$EntityService$3 = _context5.sent;
              msg = _yield$EntityService$3.msg;
              code = _yield$EntityService$3.code;
              if (code === 200) {
                this.getOvertime();
                this.$refs.multipleTable.clearSelection();
                this.$message.success(this.$t("operationSuccessful"));
                this.$emit("batchLabeled");
                // 获取处理数量接口
                // this.$store.dispatch('getNumber')
                this.$store.dispatch("getMessageNumber");
                this.$emit("fresh");
              } else {
                this.$message.error(msg);
              }
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function handleDispose(_x8) {
        return _handleDispose.apply(this, arguments);
      }
      return handleDispose;
    }(),
    // 根据工单信息返回权限信息
    workOrderLimit: function () {
      var _workOrderLimit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
        var _yield$EntityService$4, code, data, msg, roleText;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.treeLoading = true;
              _context6.next = 3;
              return _WorkOrderEntity.default.workOrderLimit(id);
            case 3:
              _yield$EntityService$4 = _context6.sent;
              code = _yield$EntityService$4.code;
              data = _yield$EntityService$4.data;
              msg = _yield$EntityService$4.msg;
              if (!(code !== 200)) {
                _context6.next = 9;
                break;
              }
              return _context6.abrupt("return", this.message.error(msg));
            case 9:
              roleText = data.order_edit;
              this.roleGrow = roleText.split(",");
              this.getRoleList();
            case 12:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function workOrderLimit(_x9) {
        return _workOrderLimit.apply(this, arguments);
      }
      return workOrderLimit;
    }(),
    // 批量受理
    getAcceptance: function () {
      var _getAcceptance = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(data1) {
        var _yield$EntityService$5, msg, code;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _WorkOrderEntity.default.updateOrderStatus(data1);
            case 2:
              _yield$EntityService$5 = _context7.sent;
              msg = _yield$EntityService$5.msg;
              code = _yield$EntityService$5.code;
              if (code === 200) {
                this.getOvertime();
                this.$refs.multipleTable.clearSelection();
                this.$emit("batchLabeled");
                // this.$store.dispatch('getNumber')
                this.$store.dispatch("getMessageNumber");
                this.$emit("fresh");
              } else {
                this.$message.error(msg);
              }
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getAcceptance(_x10) {
        return _getAcceptance.apply(this, arguments);
      }
      return getAcceptance;
    }(),
    // 获取角色列表
    getRoleList: function getRoleList(index) {
      var _this2 = this;
      this.treeLoading = true;
      this.unfoldRole = [];
      _WorkOrderEntity.default.getRoleList(_objectSpread({}, this.roleData)).then(function (res) {
        if (!res.success) {
          return _this2.$message.error(res.msg);
        }
        var dataArr = res.code || [];
        var dataArr_2 = [];
        dataArr.map(function (item) {
          item.nickname = item.username;
          _this2.roleGrow.map(function (i) {
            if (item.username === i) {
              dataArr_2.push(item);
            }
          });
        });
        _this2.roleUserData = dataArr_2 || [];
        if (index === 1) {
          _this2.roleUserData.forEach(function (item) {
            item.children.forEach(function (i) {
              if (i.nickname === _this2.roleData.username) {
                _this2.unfoldRole.push(item.id);
              }
            });
          });
        }
        _this2.treeLoading = false;
      });
    },
    // 撤销
    getRevocation: function () {
      var _getRevocation = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var res, _res2, code, msg;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              res = {};
              this.loading_transfer = true;
              _context8.next = 4;
              return _WorkOrderEntity.default.revocation(_objectSpread({}, this.revocation));
            case 4:
              res = _context8.sent;
              _res2 = res, code = _res2.code, msg = _res2.msg;
              if (code === 200) {
                this.getOvertime();
                this.$refs.multipleTable.clearSelection();
                this.$message.success(this.$t("cancelSuccess"));
                // this.$store.dispatch('getNumber')
                this.$store.dispatch("getMessageNumber");
                this.$emit("fresh");
              } else {
                this.$message.error(msg);
              }
            case 7:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getRevocation() {
        return _getRevocation.apply(this, arguments);
      }
      return getRevocation;
    }(),
    // 标记观察工单
    getMarkObservation: function () {
      var _getMarkObservation = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var res, _res3, code, msg;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              res = {};
              this.loading_transfer = true;
              _context9.next = 4;
              return _WorkOrderEntity.default.markObservation(_objectSpread({}, this.signDetail));
            case 4:
              res = _context9.sent;
              _res3 = res, code = _res3.code, msg = _res3.msg;
              if (code === 200) {
                this.getOvertime();
                this.$refs.multipleTable.clearSelection();
                this.$message.success(this.$t("operationSuccessful"));
                // this.$store.dispatch('getNumber')
                this.$emit("fresh");
              } else {
                this.$message.error(msg);
              }
            case 7:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getMarkObservation() {
        return _getMarkObservation.apply(this, arguments);
      }
      return getMarkObservation;
    }(),
    getFieldAttr: function () {
      var _getFieldAttr = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var sysNum, attrTableList;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              this.attrTable = {};
              if (!(this.sysPanelListIndex == null || this.sysPanelListIndex === "")) {
                _context10.next = 3;
                break;
              }
              return _context10.abrupt("return", false);
            case 3:
              sysNum = this.sysPanelListIndex;
              if (this.sysPanelListIndex === 999) {
                sysNum = 0;
              }
              _context10.next = 7;
              return this.$store.dispatch("getFieldAttrList", sysNum);
            case 7:
              attrTableList = _context10.sent;
              this.attrTable = attrTableList.attrTable;
              return _context10.abrupt("return", attrTableList.ifBool);
            case 10:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getFieldAttr() {
        return _getFieldAttr.apply(this, arguments);
      }
      return getFieldAttr;
    }(),
    workStatusTable: function workStatusTable(val) {
      return {
        1: this.$t("pending"),
        2: this.$t("process"),
        3: this.$t("toBeConfirmed"),
        4: this.$t("solved"),
        5: this.$t("closed"),
        6: this.$t("unsolved"),
        7: this.$t("toBeClosed"),
        101: this.$t("transferred"),
        100: this.$t("revoked"),
        102: this.$t("markedAsTruckingTicket"),
        104: this.$t("cancelObservationTicket"),
        99: this.$t("remarked")
      }[val];
    },
    priorityStatusTable: function priorityStatusTable(val) {
      return {
        1: this.$t("low"),
        2: this.$t("medium"),
        3: this.$t("high"),
        4: this.$t("urgent")
      }[val];
    },
    // 选择会触发getname方法
    getname: function getname() {
      // 获取当节点的值
      var getlist = this.$refs.tree.getCheckedNodes(true);
      // .concat(this.$refs.tree.getHalfCheckedNodes())
      // 循环遍历当前节点的值
      // for (var i in getlist) {
      // 判断子节点是否存在子节点 如果存在直接请求并且提示 false
      // if (!getlist[i].hasOwnProperty('children')) {
      if (getlist.length) {
        // 判断是否只选择一个 如果存在直接请求并且提示 false
        if (getlist.length === 1) {
          this.transferForm.user_name = getlist[0].username;
          this.transferForm.nick_name = getlist[0].nickname;
        } else {
          this.$message.error(this.$t("transferTicketTips2"));
          this.$refs.tree.setCheckedKeys([]);
          return;
        }
      } else {
        this.$message.error(this.$t("transferTicketTips1"));
        this.$refs.tree.setCheckedKeys([]);
        return;
      }
      // }
    },
    // 转单确认
    transferComfirm: function () {
      var _transferComfirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var res, _res4, code, msg;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              res = {};
              this.loading_transfer = true;
              _context11.next = 4;
              return _WorkOrderEntity.default.transcription(_objectSpread({}, this.transferForm));
            case 4:
              res = _context11.sent;
              _res4 = res, code = _res4.code, msg = _res4.msg;
              if (code === 200) {
                this.getOvertime();
                this.$refs.multipleTable.clearSelection();
                this.$message.success(this.$t("transferSuccess"));
                this.loading_transfer = false;
                this.dialogFormVisible = false;
                this.$emit("batchLabeled");
                // 获取处理数量接口
                // this.$store.dispatch('getNumber')
                this.$store.dispatch("getMessageNumber");
                this.$emit("fresh");
              } else {
                this.$message.error(msg);
                this.loading_transfer = false;
              }
            case 7:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function transferComfirm() {
        return _transferComfirm.apply(this, arguments);
      }
      return transferComfirm;
    }(),
    // 查看
    showOvertime: function showOvertime() {
      this.dialogTableVisible = true;
    },
    // 开关
    checkChange: function checkChange(e) {
      var _this3 = this;
      this.checkVal = !e;
      this.$confirm(e ? "确认开启“超时工单”的置顶功能吗?" : "确认取消“超时工单”的置顶功能吗?").then(function (a) {
        _this3.checkswitch(e);
        _this3.checkVal = e;
        _this3.$store.commit("SET_ISPINOVER", _this3.checkVal ? 1 : 0);
      }).catch(function (r) {});
    },
    checkswitch: function checkswitch(val) {
      var _this4 = this;
      _WorkOrderEntity.default.topList({
        status: val ? 1 : 0
      }).then(function (res) {
        if (res.code == 200) {
          _this4.$message.success("操作成功");
        }
      });
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    // 菜单切换
    handleMenu: function handleMenu() {
      if (this.sidebar.hide) {
        this.$store.dispatch("app/toggleSideBarHide", false);
      } else {
        this.$store.dispatch("app/toggleSideBarHide", true);
      }
    },
    handleCommandMenu: function handleCommandMenu(command) {
      if (command === "a") {
        this.resetCode();
        return;
      }
      if (command === "b") {
        this.logout();
      }
    },
    // 退出登录
    logout: function () {
      var _logout = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var _this5 = this;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              this.$confirm(this.$t("logoutTips"), this.$t("hint"), {
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
                type: "warning"
              }).then(function () {
                _this5.$store.dispatch("LogOut").then(function () {
                  location.reload();
                });
              });
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }(),
    // 密码重置
    resetCode: function resetCode() {
      this.$refs.reset.open();
    },
    // 设置语言
    setLanguage: function setLanguage(command) {
      this.$i18n.locale = command;
      localStorage.setItem("language", command);
      window.location.reload();
    }
  }
};